import { ReactNode } from 'react';

interface ResponsiveTableProps {
  children: ReactNode;
}

/**
 * Wrapper pour rendre les tables scrollables horizontalement sur mobile
 */
export function ResponsiveTable({ children }: ResponsiveTableProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        {children}
      </div>
    </div>
  );
}

interface PageHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

/**
 * Header de page responsive avec titre et action
 */
export function PageHeader({ title, description, action }: PageHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">{title}</h1>
        {description && (
          <p className="mt-1 sm:mt-2 text-sm sm:text-base text-gray-600">
            {description}
          </p>
        )}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}
